import { IMenuItem } from 'models/IMenuItem';
import cn from 'classnames';
import styles from './styles.scss';
import { hasElements, rm } from 'utils';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { useToggle } from 'hooks';
import { NotifyLink } from 'components/Shared/NotifyLink';
import { IconPlus } from 'components/Shared/Icon';
import { Item, Header, Level } from 'components/Navigation';
import connect from 'components/Shared/connect';
import { useEffect, memo } from 'react';
import { GtmHeaderNavClick } from 'store/googleTagManager/actions';
import { useDispatch } from 'react-redux';

interface NavItemProps extends IMenuItem {
  level: number;
  isMenuOpen?: boolean;
  isBot?: boolean;
}

const MENU_DEPTH = 3;
const ANIMATION_DELAY = 250;
const NavItem = memo((props: NavItemProps) => {
  const [isToggled, toggle] = useToggle(false);
  const reduxDispatch = useDispatch();

  const { subCategories, title, isMenuOpen, isBot, level, id } = props;

  useEffect(() => {
    if (!isMenuOpen && isToggled) {
      setTimeout(() => toggle(false), ANIMATION_DELAY);
    }
  }, [isMenuOpen, isToggled, toggle]);

  const hasChildren = hasElements(subCategories);
  const isOpen = isToggled && hasChildren;

  const handleOnClick = (url: string) => {
    reduxDispatch(GtmHeaderNavClick(url));
  };

  return level >= MENU_DEPTH ? (
    <Item>
      <Header>
        <NotifyLink
          onClick={() => handleOnClick(props.url)}
          ticket={props.ticket}
          url={props.url}
          {...getQaDataAttr(`link-nav-${id}`)}
        >
          {title}
        </NotifyLink>
      </Header>
    </Item>
  ) : (
    <Item>
      <Header onMouseDown={toggle} className={styles.header} {...getQaDataAttr(`link-nav-${id}`)}>
        {hasChildren && <IconPlus size="small" className={cn({ [styles.isOpen]: isOpen })} />}
        {hasChildren ? (
          title
        ) : (
          <NotifyLink
            onClick={() => handleOnClick(props.url)}
            ticket={props.ticket}
            url={props.url}
            {...getQaDataAttr(`link-nav-${id}`)}
          >
            {title}
          </NotifyLink>
        )}
      </Header>

      {hasChildren && (
        <Level className={cn({ [styles.hide]: !isOpen })}>
          <Header>
            <NotifyLink
              onClick={() => handleOnClick(props.url)}
              ticket={props.ticket}
              url={props.url}
              {...getQaDataAttr(`link-nav-${id}`)}
            >
              {rm('navigation_goto_title', title)}
            </NotifyLink>
          </Header>
          {subCategories.map(subcategory => {
            if (!subcategory.subCategories) {
              return (
                <Item key={subcategory.id}>
                  <Header>
                    <NotifyLink
                      onClick={() => handleOnClick(subcategory.url)}
                      ticket={subcategory.ticket}
                      url={subcategory.url}
                      {...getQaDataAttr(`link-nav-${subcategory.id}`)}
                    >
                      {subcategory.title}
                    </NotifyLink>
                  </Header>
                </Item>
              );
            }

            return (
              <NavItem
                isBot={isBot}
                isMenuOpen={isOpen}
                level={level + 1}
                key={subcategory.id}
                {...subcategory}
              />
            );
          })}
        </Level>
      )}
    </Item>
  );
});

interface OwnProps {
  items: IMenuItem[];
  isMenuOpen?: boolean;
  isBot?: boolean;
}
export const MenuTree = connect<OwnProps, OwnProps>(state => ({
  isMenuOpen: state.header.mainMenu.isOpen,
  isBot: state.appShell.isBot
}))(({ items, isMenuOpen, isBot }: OwnProps) => {
  return (
    <div {...getQaDataAttr({ m_nav_categories: '' })}>
      <Header invert>{rm('navigation_header_categories')}</Header>
      {items.map((i: IMenuItem) => (
        <NavItem isBot={isBot} isMenuOpen={isMenuOpen} level={1} key={i.id} {...i} />
      ))}
    </div>
  );
});
